module.exports = __webpack_public_path__ + "img/multi.7fbc4f64.jpg";